import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import FullscreenDialog from "@/components/FullscreenDialog.vue";
import UserDepartment from "./department/UserDepartment.vue";
import UserInfoEdit from "./info/UserInfoEdit.vue";
import UserMasterWorkSchedule from "./work-schedule/UserMasterWorkSchedule.vue";

type Props = {
  value: boolean;
  userId?: number;
};
type Emits = {
  (e: "input", value: boolean): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserMasterEdit',
  props: {
    value: { type: Boolean },
    userId: null
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  userId?: number;
};

const tabs = [
  { text: "基本情報", component: UserInfoEdit },
  { text: "所属別設定", component: UserDepartment },
  { text: "現状届", component: UserMasterWorkSchedule }
];




const tab = ref<number>(0);

const modelValue = computed({
  get: () => props.value,
  set: newValue => emits("input", newValue)
});

watch(modelValue, val => {
  if (val) tab.value = 0;
});

return { __sfc: true,tabs, props, emits, tab, modelValue, FullscreenDialog }
}

})